import { useWhatsNewStore } from '@src/pinia/whatsNew'
import { storeToRefs } from 'pinia'

export default function useWhatsNew() {
  const whatsNewStore = useWhatsNewStore()
  const {
    isWhatsNewDialogOpen,
    wasOpenedAutomatically,
    unreadCountString,
    updates,
    hasUpdates
  } = storeToRefs(whatsNewStore)

  const {
    closeWhatsNewDialog,
    openWhatsNewDialog,
    markAsRead,
    loadMore: storeLoadMore
  } = whatsNewStore

  const loadMore = (entries: IntersectionObserverEntry, observer: IntersectionObserver, isIntersecting: boolean) => {
    if (isIntersecting) {
      storeLoadMore()
    }
  }

  return {
    wasOpenedAutomatically,
    isWhatsNewDialogOpen,
    closeWhatsNewDialog,
    openWhatsNewDialog,
    markAsRead,
    loadMore,
    unreadCountString,
    updates,
    hasUpdates
  }
}
